const formatCosphi = (cosphi?: number): string => {
    if (typeof cosphi !== 'number') return cosphi
    const [integer, rest] = cosphi.toFixed(2).split('.')
    const intLimit = integer.length - 1
    const intPart = integer
        .split('')
        .map((s, i) => (i === intLimit || (intLimit - i) % 3 ? s : `${s},`))
        .join('')
    return `${intPart}.${rest}`
}

export default formatCosphi
